var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { getTestId, isValidObject, BLACK_700, Typography } from '@airtel/air-design-system';
import { View, Image } from 'react-native';
import { getUPIPayWidgetStyles } from './UPIPayWidgetStyles';
export var UPIPayWidgetComponent = props => {
  var _props$testID = props.testID,
    testID = _props$testID === void 0 ? 'UPIPayWidgetContainer' : _props$testID,
    text = props.text,
    _props$logoUrls = props.logoUrls,
    logoUrls = _props$logoUrls === void 0 ? [] : _props$logoUrls,
    OtherTypographyProps = props.OtherTypographyProps,
    style = props.style,
    restProps = __rest(props, ["testID", "text", "logoUrls", "OtherTypographyProps", "style"]);
  var widgetStyles = getUPIPayWidgetStyles();
  return _jsxs(View, Object.assign({
    style: [widgetStyles.container, style]
  }, getTestId(testID), restProps, {
    children: [!!text && _jsx(Typography, Object.assign({
      text: text,
      color: BLACK_700,
      type: "body-single-line-xs",
      testID: testID + '_text'
    }, OtherTypographyProps, restProps)), isValidObject(logoUrls) && _jsx(View, Object.assign({
      style: widgetStyles.logoContainer
    }, {
      children: logoUrls.map((url, index) => {
        return _jsx(Image, Object.assign({
          resizeMode: "contain",
          style: widgetStyles.logoStyle,
          source: {
            uri: url
          }
        }, getTestId(testID, "image-" + index), restProps), index);
      })
    }))]
  }));
};
UPIPayWidgetComponent.genericRendererKey = 'AirUPIPayWidget';